import DefaultFormStyle from 'forms-utils-lib/formStyle/constants/DefaultFormStyle';
const createFormStyle = (args = {}) => {
  return Object.assign({}, DefaultFormStyle, args);
};
export default createFormStyle;